const VISION_APPLY_OPERATION_TYPES = ['In Crop', 'On Fallow']

export function getFieldAnalyzerLabel(operationType) {
    if (!operationType || operationType === 'Unknown') return null

    return VISION_APPLY_OPERATION_TYPES.includes(operationType) ? 'VisionApply' : 'SenseApply'
}
